import React, { useEffect, useRef, useState } from 'react';
import Burbuja from './Burbuja';
import { parsearFechaChat } from './fechas';

// Lista de burbujas con scroll inteligente: si el usuario está abajo, baja
// solo al llegar mensajes; si está leyendo arriba, avisa "N mensajes nuevos".
export default function ListaMensajes({ mensajes, esPropio, reenviandoId, onReenviar }) {
  const ref = useRef(null);
  const [nuevos, setNuevos] = useState(0);
  const cantidadPrevia = useRef(0);
  const pegadoAbajo = useRef(true);

  const irAlFinal = () => {
    const el = ref.current;
    if (el) {
      el.scrollTop = el.scrollHeight;
    }
    setNuevos(0);
  };

  const onScroll = () => {
    const el = ref.current;
    if (!el) {
      return;
    }
    pegadoAbajo.current = el.scrollHeight - el.scrollTop - el.clientHeight < 24;
    if (pegadoAbajo.current) {
      setNuevos(0);
    }
  };

  useEffect(() => {
    const llegaron = mensajes.length - cantidadPrevia.current;
    cantidadPrevia.current = mensajes.length;
    if (llegaron <= 0) {
      return;
    }
    if (pegadoAbajo.current) {
      irAlFinal();
    } else {
      setNuevos((n) => n + llegaron);
    }
  }, [mensajes]);

  return (
    <div className="chat-burbujas" ref={ref} onScroll={onScroll}>
      {mensajes.map((m, i) => (
        <Burbuja
          key={m.identificador || i}
          mensaje={m}
          fecha={parsearFechaChat(m.fecha)}
          propio={esPropio(m)}
          reenviando={reenviandoId === m.identificador}
          onReenviar={onReenviar}
        />
      ))}
      {nuevos > 0 && (
        <button type="button" className="chat-nuevos" onClick={irAlFinal}>
          ↓ {nuevos} {nuevos === 1 ? 'mensaje nuevo' : 'mensajes nuevos'}
        </button>
      )}
    </div>
  );
}
